<template>

<core-content-wrapper :loading="!is.ready || is.refreshing || is.fetching === 'all'">

	<core-filter :loading="is.fetching" :filter="insightName" v-on:refresh="onRefresh">

	</core-filter>

	<core-content-page v-if="is.reset && is.fetching !== 'all'">

		<core-content-page-inner v-show="is.ready" :is-grid="true">

			<com-profile :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-overview :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-recent :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-wins :fetching="is.fetching" :your="your" :you="you" :size="4" />

			<com-groups :fetching="is.fetching" :your="your" :you="you" :size="2" />
			
			<com-games :fetching="is.fetching" :your="your" :you="you" :size="6" />

			<com-heatmap :fetching="is.fetching" :your="your" :you="you" :period="period" :size="6" />

			<com-weight :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-counts :fetching="is.fetching" :your="your" :you="you" :size="2" />

			<com-duration :fetching="is.fetching" :your="your" :you="you" :size="2" />

		</core-content-page-inner>

	</core-content-page>

</core-content-wrapper>

</template>

<script>

import Section from './common/Section.js'

import comProfile from './player/Profile'
import comOverview from './player/Overview'
import comGroups from './player/Groups'
import comWeight from './player/Weight'
import comRecent from './player/Recent'
import comHeatmap from './player/Heatmap'
import comGames from './player/Games'
import comCounts from './player/Counts'
import comDuration from './player/Duration'
import comWins from './player/Wins'

export default {

	mixins: [Section],

	components: {
		'com-profile': comProfile,
		'com-overview': comOverview,
		'com-heatmap': comHeatmap,
		'com-recent': comRecent,
		'com-groups': comGroups,
		'com-games': comGames,
		'com-weight': comWeight,
		'com-counts': comCounts,
		'com-duration': comDuration,
		'com-wins': comWins
	},

	data: function() {

		return {

			insightName: 'player',
			dynamicInsights: [
				'wins.threshold',
				'wins.band'
			]

		}

	},

	computed: {

		playerName: function() {

			return this.$store.getters['page/insights/player/player'].name

		}

	},

	methods: {

		afterLoad: function() {

			document.title = this.playerName.toLowerCase() + ' | ' + document.title

		}

	}

}

</script>

<style scoped>

</style>